import tinycolor from "tinycolor2";
import jssVariables from "../jss_setup";

export const searchStrip = {
  searchStrip: {
    loader: {
      color: "white",
      "& .rs-loader-content": {
        color: "white",
      },
      "& .rs-loader-spin::after": {
        borderColor: `${jssVariables.colors.base_color} transparent transparent`,
      },
    },
    background: tinycolor(jssVariables.colors.base_color)
      .lighten(55)
      .toHexString(),
  },
  searchStripDest: {
    borderBottom: `2px solid ${jssVariables.colors.text.dark}`,
  },
  searchStripDates: {
    borderBottom: `2px solid ${jssVariables.colors.text.dark}`,
  },
  searchStripPax: {
    borderBottom: `2px solid ${jssVariables.colors.text.dark}`,
  },
  btns: {
    background: tinycolor(jssVariables.colors.base_color)
      .lighten(55)
      .toHexString(),
  },
};

export const roomGroupPrice = {
  cxlFree: {
    color: "green",
  },
  cxlChargeable: {
    color: "red",
  },
  priceComponent: {
    fontWeight: "bold",
  },
};

export const roomGroup = {};

export const hotelDetails = {};

export const packageViewStyles = {
  videoContainer: {
    marginBottom: `calc(${jssVariables.normal_gap} * 4)`,
    marginTop: `calc(${jssVariables.normal_gap} * 4)`,
    smallscreen: {
      padding: "0px 10vw",
      marginTop: `calc(${jssVariables.normal_gap} * 4)`,
    },
  },
};

export const tourViewStyles = {
  videoContainer: {
    marginTop: `calc(${jssVariables.normal_gap} * 4)`,
    marginBottom: `calc(${jssVariables.normal_gap} * 4)`,
    smallscreen: {
      padding: "0px 10vw",
      marginTop: `calc(${jssVariables.normal_gap} * 5)`,
      marginBottom: `calc(${jssVariables.normal_gap} * 5)`,
    },
  },
};

export const lpMainSearchFormStyles = {
  mainSearchForm: {
    background: "rgba(20, 42, 62, 0.7)",
    transform: " translateY(38%)",
    smallscreen: {
      background: "rgba(20, 42, 62, 0.7)",
      // transform: "translateY(38%)",
    },
  },
  hotelSearchForm: {
    gridGap: `calc(${jssVariables.normal_gap} * 1)`,
  },
  selector: {
    background: "rgba(40, 82, 122, .4)",
  },
  mainSFDestinationsPicker: {
    DestinationsPicker: {
      gridGap: 0,
    },
    label: {
      color: "white",
    },
  },
  datePickerContainer: {
    gridGap: 0,
  },
  datePickerLabel: {
    color: "white",
  },
  PaxPicker: {
    label: {
      color: "white",
      textTransform: "uppercase",
    },
  },
  searchBtn: {
    searchBtn: {
      fontSize: "medium",
    },
  },
};
export const productStyles = {
  Description: {
    smallscreen: {},
  },
  contentPKG: {
    gridTemplateRows: "auto 15vh auto auto auto auto",
  },
  priceComponent: {
    fontSize: "x-large",
  },
};
